<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Calf Health
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">

        <h3 :class="isRemovedSubsection('cows_winteres_rota_vaccinated') ? 'subsection-disabled' : ''">
          <u> % cows wintered that were Rotavirus vaccinated </u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'cows_winteres_rota_vaccinated')">
            <span class="glyphicon" :class="isRemovedSubsection('cows_winteres_rota_vaccinated') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Cows Vaccinated</th>
              <th>Total Cows Wintered</th>
              <th>Percent Total Cows Wintered</th>
              <th>Region Avg. Percent Total Cows Wintered</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, index) in model.CHARTS.roto_vaccinations" :key="index"
              :class="getRowClass(model.CHARTS.roto_vaccinations, 'Season', index)">

              <td class="text-left">{{ rv["Season"] }}</td>
              <td class="text-left">{{ rv["Cows Vaccinated"] }}</td>
              <td class="text-left">{{ rv["Total Cows Wintered"] }}</td>
              <td class="text-left">{{ rv["Percent Total Cows Wintered"] }}</td>
              <td class="text-left">{{ rv["Region Avg. Percent Total Cows Wintered"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('calf_health_products_purchased') ? 'subsection-disabled' : ''">
          <u> Seasonal Calf health products purchased </u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'calf_health_products_purchased')">
            <span class="glyphicon" :class="isRemovedSubsection('calf_health_products_purchased') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Product </th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sp, index) in model.CHARTS.scour_products" :key="index"
              :class="getRowClass(model.CHARTS.scour_products, 'Season', index)">

              <td class="text-left">{{ sp["Season"] }}</td>
              <td class="text-left">{{ sp["Product"] }}</td>
              <td class="text-left">{{ sp["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('calf_disbud_purchases') ? 'subsection-disabled' : ''">
          <u>Seasonal Calf disbud purchases </u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'calf_disbud_purchases')">
            <span class="glyphicon" :class="isRemovedSubsection('calf_disbud_purchases') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Product/Service</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dp, index) in model.CHARTS.disbud_products" :key="index"
              :class="getRowClass(model.CHARTS.disbud_products, 'Season', index)">

              <td class="text-left">{{ dp["Season"] }}</td>
              <td class="text-left">{{ dp["Product/Service"] }}</td>
              <td class="text-left">{{ dp["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.calf_health_keypoints || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.calf_health_actions || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [ mixin ],
  props: ['model'],
  data() {
    return {
      stepName: 'CalfHealth',
    }
  },
};
</script>
